import _ from 'lodash';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { numStr } from '../../components/common/Translate';
import { HT_REFERENTIALS, listTVA, REACT_APP_API, TTC_REFERENTIALS } from '../../config';
import { currencySign } from '../../Utils/currencySign';

const usePdfCost = (recordKey, referential, language) => {
  const [report, setReport] = useState(null);
  const [country, setCountry] = useState(null);
  const [fileNumber, setFileNumber] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [symbol, setSymbol] = useState(currencySign());
  const zoneList = ['body', 'servicing', 'wheels', 'road_test', 'inner', 'motor'];

  const fetchInspection = async () => {
    setIsLoading(true);
    try {
      const req = new Request(`${REACT_APP_API}/buyer/public/records/${recordKey}`, {
        method: 'GET',
      });
      let response = await fetch(req);
      response = await response.json();
      setReport(response.inspection.report);
      setCountry(response.country);
      setFileNumber(response.inspection.id);
      if (TTC_REFERENTIALS.includes(referential) || referential.includes('external')) setSymbol('TTC');
      else if (HT_REFERENTIALS.includes(referential) || referential.includes('internal')) setSymbol('HT');
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchInspection();
    window.dispatchEvent(new CustomEvent('changeLanguage', { detail: { language } }));
  }, [recordKey]);

  const infos = {};
  if (report) {
    if (!infos?.VAT) infos.VAT = (listTVA[country] * 100) % 100;
    if (TTC_REFERENTIALS.includes(referential) || referential.includes('external')) {
      if (!infos?.costInclTax) infos.costInclTax = report?.totals[referential];
      if (!infos?.costExlTax)
        infos.costExlTax = ((100 * infos.costInclTax) / (100 + ((listTVA[country] * 100) % 100))).toFixed(2);
      if (!infos?.TVA) infos.TVA = infos.costInclTax - infos.costExlTax;
    } else if (HT_REFERENTIALS.includes(referential) || referential.includes('internal')) {
      if (!infos?.costExlTax) infos.costExlTax = report?.totals[referential];
    }
    infos.vehicleInfos = {
      file_number: fileNumber,
      registration_plate: _.get(report.vehicle, 'registration')?.[1],
      pointOfSaleName: _.get(report.expertise, 'placeExpertise')?.[1],
      inspection_made_by: _.get(report.expertise, 'buyerName')?.[1],
      expertise_date: moment(_.get(report.expertise, 'dateExpertise')?.[1]).format('DD/MM/YYYY'),
      vehicule_brand: _.get(report.vehicle, 'brandLabel')?.[1],
      vehicule_model: _.get(report.vehicle, 'modelLabel')?.[1],
      registrationDate: moment(_.get(report.vehicle, 'registrationDate')?.[1]).format('DD/MM/YYYY'),
      vehicule_test_mileage: numStr(_.get(report.vehicle, 'vehicule_test_mileage')?.[1]),
      vin_number: _.get(report.vehicle, 'vin')?.[1],
    };
  }
  return { isLoading, infos, report, symbol, zoneList, country };
};

export default usePdfCost;
